<ul class="list-unstyled text-center social">
    <li 
        matRipple 
        class="facebook"
        nz-tooltip
        nzTooltipPlacement="bottom"
        [nzTooltipTitle]="'Follow us on Facebook' | translate">
        <a href="https://www.facebook.com/codes.roots.7" target="_blank">
            <i class="fab fa-facebook-f"></i>
        </a>
    </li>
    <li 
        matRipple 
        class="twitter"
        nz-tooltip
        nzTooltipPlacement="bottom"
        [nzTooltipTitle]="'Follow us on Twitter' | translate">
        <a href="https://www.twitter.com/CodesRoots" target="_blank">
            <i class="fab fa-twitter"></i>
        </a>
    </li>  
    <li 
        matRipple 
        class="instagram"
        nz-tooltip
        nzTooltipPlacement="bottom"
        [nzTooltipTitle]="'Follow us on Instagram' | translate">
        <a href="https://www.instagram.com/CodesRoots" target="_blank">
            <i class="fab fa-instagram"></i>
        </a>
    </li>
    <li 
        matRipple 
        class="youtube"
        nz-tooltip
        nzTooltipPlacement="bottom"
        [nzTooltipTitle]="'Follow us on YouTube' | translate">
        <a href="https://www.youtube.com/channel/UCXyef040FvSzu_M3g7jpb0w" target="_blank">
            <i class="fab fa-youtube"></i>
        </a>
    </li>     
    <li 
        matRipple 
        class="behance"
        nz-tooltip
        nzTooltipPlacement="bottom"
        [nzTooltipTitle]="'Follow us on Behance' | translate">
        <a href="https://www.behance.net/CodesRoots" target="_blank">
            <i class="fab fa-behance"></i>
        </a>
    </li>   
    <li 
        matRipple 
        class="linkedin"
        nz-tooltip
        nzTooltipPlacement="bottom"
        [nzTooltipTitle]="'Follow us on Linkedin' | translate">
        <a href="https://eg.linkedin.com/in/Codes-Roots" target="_blank">
            <i class="fab fa-linkedin-in"></i>
        </a>
    </li> 
    <li 
        matRipple 
        class="deviantart"
        nz-tooltip
        nzTooltipPlacement="bottom"
        [nzTooltipTitle]="'Follow us on DeviantArt' | translate">
        <a href="https://www.dribbble.com/CodesRoots" target="_blank">
            <i class="fab fa-deviantart"></i>
        </a>
    </li>     
    <li 
        matRipple 
        class="dribbble"
        nz-tooltip
        nzTooltipPlacement="bottom"
        [nzTooltipTitle]="'Follow us on Dribble' | translate">
        <a href="https://www.dribbble.com/CodesRoots" target="_blank">
            <i class="fab fa-dribbble"></i>
        </a>
    </li>                                                                                                                    
</ul>